import React from "react";

const PureHTML = ({html_string}) => {
    return <div dangerouslySetInnerHTML={{__html: html_string}} style={{textAlign: 'initial'}}/>
}

export default PureHTML;
